import React, { useState } from "react";
import Swal from "sweetalert2";

const MitraForm = () => {
  const [formData, setFormData] = useState({
    namaMitra: "",
    kategoriMitra: "",
    bidangDeskripsi: "",
    alamatWeb: "",
    companyProfile: null,
    namaPIC: "",
    emailPIC: "",
    noTeleponPIC: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, companyProfile: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.companyProfile) {
      Swal.fire({
        icon: "error",
        title: "Kesalahan",
        text: "Silakan unggah file.",
      });
      return;
    }
  
    const formDataToSend = new FormData();
    formDataToSend.append("partner", formData.namaMitra);
    formDataToSend.append("category", formData.kategoriMitra);
    formDataToSend.append("description", formData.bidangDeskripsi);
    formDataToSend.append("url", formData.alamatWeb);
    formDataToSend.append("documents", formData.companyProfile);
    formDataToSend.append("name", formData.namaPIC);
    formDataToSend.append("email", formData.emailPIC);
    formDataToSend.append("number", formData.noTeleponPIC);
  
    fetch("https://cms.okoce.net/api/admin/cooperation-partner-forms", {
      method: "POST",
      body: formDataToSend,
      headers: {
        Accept: "application/json",
      },
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.errors) {
        Swal.fire({
          icon: "error",
          title: "Kesalahan Pengiriman",
          text: `Kesalahan: ${JSON.stringify(data.errors)}`,
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Formulir Dikirim!",
          text: "Pengajuan kemitraan Anda telah berhasil dikirimkan.",
        });
  
        setFormData({
          namaMitra: "",
          kategoriMitra: "",
          bidangDeskripsi: "",
          alamatWeb: "",
          companyProfile: null,
          namaPIC: "",
          emailPIC: "",
          noTeleponPIC: "",
        });
      }
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-6 p-8 bg-gray-50 rounded-md max-w-7xl mx-auto"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="text-gray-700 font-medium">
            Nama Mitra: <span className="text-[#e01f31]">*</span>
            <input
              type="text"
              name="namaMitra"
              value={formData.namaMitra}
              onChange={handleChange}
              placeholder="Masukkan nama mitra"
              required
              className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50 placeholder-gray-400"
            />
          </label>
        </div>

        <div>
          <label className="text-gray-700 font-medium">
            Kategori Mitra: <span className="text-[#e01f31]">*</span>
            <select
              name="kategoriMitra"
              value={formData.kategoriMitra}
              onChange={handleChange}
              required
              className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50"
            >
              <option value="" disabled>Pilih Kategori</option>
              <option value="Mitra Kerjasama Swasta & Pemerintah">
                Mitra Kerjasama Swasta & Pemerintah
              </option>
              <option value="Mitra Kerjasama Pendidikan">
                Mitra Kerjasama Pendidikan
              </option>
              <option value="Mitra Kerjasama Penggerak/Komunitas">
                Mitra Kerjasama Penggerak/Komunitas
              </option>
            </select>
          </label>
        </div>
      </div>

      <label className="text-gray-700 font-medium">
        Bidang/Deskripsi Mitra: <span className="text-[#e01f31]">*</span>
        <textarea
          name="bidangDeskripsi"
          value={formData.bidangDeskripsi}
          onChange={handleChange}
          placeholder="Jelaskan bidang atau deskripsi mitra"
          rows={5}
          required
          className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50 placeholder-gray-400"
        />
      </label>

      <label className="text-gray-700 font-medium">
        Alamat Web/Sosial Media:
        <input
          type="url"
          name="alamatWeb"
          value={formData.alamatWeb}
          onChange={handleChange}
          placeholder="Masukkan link alamat web atau sosial media"
          className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50 placeholder-gray-400"
        />
      </label>

      <label className="text-gray-700 font-medium">
        Company Profile (Upload Dokumen): <span className="text-[#e01f31]">*</span>
        <input
          type="file"
          name="companyProfile"
          onChange={handleFileChange}
          required
          className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50"
        />
      </label>

      <div className="mt-8 text-xl font-semibold text-gray-700">INFORMASI PIC</div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="text-gray-700 font-medium">
            Nama PIC: <span className="text-[#e01f31]">*</span>
            <input
              type="text"
              name="namaPIC"
              value={formData.namaPIC}
              onChange={handleChange}
              placeholder="Masukkan nama PIC"
              required
              className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50 placeholder-gray-400"
            />
          </label>
        </div>

        <div>
          <label className="text-gray-700 font-medium">
            Email: <span className="text-[#e01f31]">*</span>
            <input
              type="email"
              name="emailPIC"
              value={formData.emailPIC}
              onChange={handleChange}
              placeholder="Masukkan email PIC"
              required
              className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50 placeholder-gray-400"
            />
          </label>
        </div>
      </div>

      <div>
        <label className="text-gray-700 font-medium">
          No Telepon: <span className="text-[#e01f31]">*</span>
          <input
            type="tel"
            name="noTeleponPIC"
            value={formData.noTeleponPIC}
            onChange={handleChange}
            placeholder="Masukkan nomor telepon PIC"
            required
            className="mt-2 p-3 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#1c75ac] w-full bg-gray-50 placeholder-gray-400"
          />
        </label>
      </div>

      <button
        type="submit"
        className="mt-6 px-12 py-4 text-xl mobile:text-base font-semibold text-white bg-[#1c75ac] rounded-full hover:bg-blue-700 w-full"
      >
        MULAI BEKERJASAMA
      </button>
    </form>
  );
};

export default MitraForm;
